import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
    selector: 'app-option-select',
    templateUrl: './option-select.component.html',
    styleUrls: ['./option-select.component.css'],
    standalone: false
})
export class OptionSelectComponent implements AfterViewInit {
  @Input() options: string[] = [];
  selectedOption: string = '';
  @Input() key!: string;
  @Output() selected = new EventEmitter();
  @ViewChild('select') select!: ElementRef | any;

  modelChange($event: any) {
    console.log($event);
    this.selectedOption = $event;
    this.selected.emit({ key: this.key, option: this.selectedOption });
  }

  emitSelection() {
    this.selected.emit({ key: this.key, option: this.selectedOption });
  }

  ngAfterViewInit() {
    this.selectedOption = this.options[0];
    this.select.toggle();
  }
}
